import { render, staticRenderFns } from "./StoreAddress.vue?vue&type=template&id=37f176ba&scoped=true"
import script from "./StoreAddress.vue?vue&type=script&lang=js"
export * from "./StoreAddress.vue?vue&type=script&lang=js"
import style0 from "./StoreAddress.vue?vue&type=style&index=0&id=37f176ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f176ba",
  null
  
)

export default component.exports